/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventdetectorDefinitionNotifyInner
 */
export interface EventdetectorDefinitionNotifyInner {
    /**
     * 
     * @type {string}
     * @memberof EventdetectorDefinitionNotifyInner
     */
    who?: string;
    /**
     * 
     * @type {string}
     * @memberof EventdetectorDefinitionNotifyInner
     */
    action?: string;
}

/**
 * Check if a given object implements the EventdetectorDefinitionNotifyInner interface.
 */
export function instanceOfEventdetectorDefinitionNotifyInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EventdetectorDefinitionNotifyInnerFromJSON(json: any): EventdetectorDefinitionNotifyInner {
    return EventdetectorDefinitionNotifyInnerFromJSONTyped(json, false);
}

export function EventdetectorDefinitionNotifyInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventdetectorDefinitionNotifyInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'who': !exists(json, 'who') ? undefined : json['who'],
        'action': !exists(json, 'action') ? undefined : json['action'],
    };
}

export function EventdetectorDefinitionNotifyInnerToJSON(value?: EventdetectorDefinitionNotifyInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'who': value.who,
        'action': value.action,
    };
}

